// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Variables */
:root {
  --primary-gradient: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  --secondary-gradient: linear-gradient(135deg, #26c6da 0%, #00acc1 100%);
  --success-gradient: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);
  --danger-gradient: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
  --card-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --transition: all 0.3s ease;
}

.admin-panel {
  min-height: 100vh;
  background: #f8fafc;
  padding: 0;
}

.admin-header {
  background: var(--primary-gradient);
  padding: 24px 32px;
  box-shadow: var(--card-shadow);
  margin-bottom: 2px;
}

.admin-header h1 {
  color: white;
  font-size: 1.75rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.admin-panel .admin-header .logout-btn {
  padding: 10px 20px;
  background: var(--danger-color);
  color: white;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease-in-out;
}

.admin-panel .admin-header .logout-btn:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.admin-panel .admin-header .logout-btn:active {
  transform: translateY(0);
  box-shadow: none;
}

.admin-nav {
  background: white;
  padding: 0 32px;
  border-bottom: none;
  box-shadow: var(--card-shadow);
  display: flex;
  gap: 8px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.tab-btn {
  padding: 16px 24px;
  border: none;
  background: none;
  color: #64748b;
  cursor: pointer;
  font-weight: 500;
  transition: var(--transition);
  border-radius: 0;
  position: relative;
}

.tab-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: var(--primary-gradient);
  transition: var(--transition);
  transform: translateX(-50%);
}

.tab-btn:hover::after {
  width: 100%;
}

.tab-btn.active {
  background: transparent;
  color: #2196f3;
}

.tab-btn.active::after {
  width: 100%;
}

.admin-content {
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Modern Card Styling */
.add-form, .edit-form, .business-checks {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* Enhanced Form Controls */
.add-form input,
.add-form select,
.add-form textarea,
.edit-form input,
.edit-form select,
.edit-form textarea {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: var(--transition);
  background: #f8fafc;
}

.add-form input:focus,
.add-form select:focus,
.add-form textarea:focus,
.edit-form input:focus,
.edit-form select:focus,
.edit-form textarea:focus {
  outline: none;
  border-color: #2196f3;
  background: white;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.add-form button {
  background: var(--success-color);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-form button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Modern Table Styling */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 0;
}

th {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
  padding: 16px;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

td {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  color: #334155;
}

tr:hover td {
  background: #f1f5f9;
}

/* Enhanced Buttons */
.edit-btn, .delete-btn, .add-credits-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  transition: var(--transition);
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.edit-btn {
  background: var(--secondary-gradient);
  color: white;
}

.delete-btn {
  background: var(--danger-gradient);
  color: white;
}

.add-credits-btn {
  background: var(--success-gradient);
  color: white;
}

/* Credits Management Enhancement */
.credits-management {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.credits-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin: 16px 0;
}

.credits-stat {
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.credits-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 4px;
}

.credits-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
}

/* Environment Badge Enhancement */
.environment-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.environment-badge.test {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.environment-badge.live {
  background: rgba(239, 83, 80, 0.1);
  color: #ef5350;
}

/* Add some spacing for the environment select */
select[name="environment"] {
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.notifications-section {
  padding: 20px;
}

.section-description {
  margin-bottom: 20px;
  color: #666;
}

.notification-test-form {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notification-test-form .form-group {
  margin-bottom: 15px;
}

.notification-test-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.notification-test-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.create-notification-btn {
  width: 100%;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
}

.create-notification-btn:hover {
  background-color: #388E3C;
}

.create-notification-btn:disabled {
  background-color: #9E9E9E;
  cursor: not-allowed;
}

.notification-result {
  margin-top: 15px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.notification-result.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #388E3C;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.notification-result.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #D32F2F;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.notification-info {
  margin-top: 30px;
}

.notification-types-list {
  list-style-type: none;
  padding: 0;
}

.notification-types-list li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.notification-types-list li:last-child {
  border-bottom: none;
}

.credits-management {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 5px;
}

.credits-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.credits-field input {
  width: 120px;
}

.credits-info {
  display: flex;
  gap: 20px;
  font-size: 0.9em;
  color: #666;
}

.add-credits-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 5px;
}

.add-credits-btn:hover {
  background-color: #218838;
}

@media (max-width: 768px) {
  .admin-header {
    padding: 20px;
  }

  .admin-nav {
    padding: 0 16px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .admin-content {
    padding: 16px;
  }

  .credits-info {
    grid-template-columns: 1fr;
  }

  .table-container {
    margin: 0 -16px;
    border-radius: 0;
  }

  .add-form {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .add-form input,
  .add-form select,
  .add-form textarea {
    margin-bottom: 8px;
  }

  table, thead, tbody, th, td, tr {
    display: block;
  }

  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin-bottom: 16px;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
  }

  td {
    display: flex;
    flex-direction: column;
    border: none;
    padding: 8px 12px;
    text-align: left;
    min-height: 60px;
    position: relative;
  }

  td:before {
    content: attr(data-label);
    font-weight: bold;
    margin-bottom: 4px;
    font-size: 0.85rem;
    color: var(--text-secondary);
    position: static;
  }

  td:last-child {
    flex-direction: column;
    gap: 8px;
  }

  td:last-child:before {
    margin-bottom: 8px;
  }

  td:last-child > div {
    display: flex;
    gap: 8px;
  }

  .edit-form {
    padding: 16px;
  }

  .edit-form form > div {
    margin-bottom: 12px;
  }

  .form-buttons {
    flex-direction: column;
    gap: 8px;
  }

  .form-buttons button {
    width: 100%;
  }

  .edit-btn,
  .delete-btn {
    flex: 1 1;
    text-align: center;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 1.2rem;
  color: var(--text-secondary);
}

.edit-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.edit-form h3 {
  margin-top: 0;
  margin-bottom: 20px;
}

.edit-form form > div {
  margin-bottom: 15px;
}

.edit-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.edit-form input,
.edit-form select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.form-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.form-buttons button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-buttons button[type="submit"] {
  background: #4CAF50;
  color: white;
}

.form-buttons button[type="button"] {
  background: #f44336;
  color: white;
}

.reports-section {
  padding: 20px;
}

.business-checks {
  margin-bottom: 30px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.business-checks h3 {
  margin-bottom: 15px;
  color: #333;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.business-summary {
  margin: 10px 0;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.business-summary p {
  margin: 5px 0;
  font-weight: bold;
}

/* Add some spacing for the environment select */
select[name="environment"] {
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.notifications-section {
  padding: 20px;
}

.section-description {
  margin-bottom: 20px;
  color: #666;
}

.notification-test-form {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notification-test-form .form-group {
  margin-bottom: 15px;
}

.notification-test-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.notification-test-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.create-notification-btn {
  width: 100%;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
}

.create-notification-btn:hover {
  background-color: #388E3C;
}

.create-notification-btn:disabled {
  background-color: #9E9E9E;
  cursor: not-allowed;
}

.notification-result {
  margin-top: 15px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.notification-result.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #388E3C;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.notification-result.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #D32F2F;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.notification-info {
  margin-top: 30px;
}

.notification-types-list {
  list-style-type: none;
  padding: 0;
}

.notification-types-list li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.notification-types-list li:last-child {
  border-bottom: none;
}

.credits-management {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 5px;
}

.credits-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.credits-field input {
  width: 120px;
}

.credits-info {
  display: flex;
  gap: 20px;
  font-size: 0.9em;
  color: #666;
}

.add-credits-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 5px;
}

.add-credits-btn:hover {
  background-color: #218838;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #334155;
}

.credits-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.credits-input-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.credits-input-group input:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.quick-credit-buttons {
  display: flex;
  gap: 8px;
}

.quick-credit-buttons button {
  flex: 1 1;
  padding: 8px 16px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.quick-credit-buttons button:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.quick-credit-buttons button:active {
  transform: translateY(0);
}

.credits-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.credits-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
  background: white;
  transition: all 0.2s ease;
}

.credits-input:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.credits-input::-webkit-inner-spin-button,
.credits-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.credits-input[type=number] {
  -moz-appearance: textfield;
}

.credits-actions {
  margin-top: 16px;
}

.credits-stat {
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.credits-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 8px;
}

.credits-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
}

.manual-checks-group {
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.manual-checks-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.manual-checks-info {
  flex: 1 1;
}

.manual-checks-info label {
  display: block;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}

.manual-checks-info small {
  color: #64748b;
  font-size: 0.875rem;
}

/* Toggle Switch Styles */
.toggle-container {
  position: relative;
  min-width: 60px;
}

.toggle-checkbox {
  display: none;
}

.toggle-label {
  display: block;
  width: 60px;
  height: 34px;
  border-radius: 17px;
  background: #cbd5e1;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.toggle-label:before {
  content: '';
  display: block;
  width: 26px;
  height: 26px;
  border-radius: 13px;
  background: white;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.toggle-checkbox:checked + .toggle-label {
  background: #2196f3;
}

.toggle-checkbox:checked + .toggle-label:before {
  transform: translateX(26px);
}

.toggle-checkbox:focus + .toggle-label {
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
} `, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/* Modern Variables */\n:root {\n  --primary-gradient: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  --secondary-gradient: linear-gradient(135deg, #26c6da 0%, #00acc1 100%);\n  --success-gradient: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);\n  --danger-gradient: linear-gradient(135deg, #ef5350 0%, #e53935 100%);\n  --card-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --transition: all 0.3s ease;\n}\n\n.admin-panel {\n  min-height: 100vh;\n  background: #f8fafc;\n  padding: 0;\n}\n\n.admin-header {\n  background: var(--primary-gradient);\n  padding: 24px 32px;\n  box-shadow: var(--card-shadow);\n  margin-bottom: 2px;\n}\n\n.admin-header h1 {\n  color: white;\n  font-size: 1.75rem;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.admin-panel .admin-header .logout-btn {\n  padding: 10px 20px;\n  background: var(--danger-color);\n  color: white;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease-in-out;\n}\n\n.admin-panel .admin-header .logout-btn:hover {\n  background: var(--primary-dark);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-panel .admin-header .logout-btn:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n.admin-nav {\n  background: white;\n  padding: 0 32px;\n  border-bottom: none;\n  box-shadow: var(--card-shadow);\n  display: flex;\n  gap: 8px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.tab-btn {\n  padding: 16px 24px;\n  border: none;\n  background: none;\n  color: #64748b;\n  cursor: pointer;\n  font-weight: 500;\n  transition: var(--transition);\n  border-radius: 0;\n  position: relative;\n}\n\n.tab-btn::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 0;\n  height: 3px;\n  background: var(--primary-gradient);\n  transition: var(--transition);\n  transform: translateX(-50%);\n}\n\n.tab-btn:hover::after {\n  width: 100%;\n}\n\n.tab-btn.active {\n  background: transparent;\n  color: #2196f3;\n}\n\n.tab-btn.active::after {\n  width: 100%;\n}\n\n.admin-content {\n  padding: 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Modern Card Styling */\n.add-form, .edit-form, .business-checks {\n  background: white;\n  border-radius: 12px;\n  box-shadow: var(--card-shadow);\n  padding: 24px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Enhanced Form Controls */\n.add-form input,\n.add-form select,\n.add-form textarea,\n.edit-form input,\n.edit-form select,\n.edit-form textarea {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: var(--transition);\n  background: #f8fafc;\n}\n\n.add-form input:focus,\n.add-form select:focus,\n.add-form textarea:focus,\n.edit-form input:focus,\n.edit-form select:focus,\n.edit-form textarea:focus {\n  outline: none;\n  border-color: #2196f3;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.add-form button {\n  background: var(--success-color);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.add-form button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Modern Table Styling */\n.table-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: var(--card-shadow);\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\ntable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-top: 0;\n}\n\nth {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #475569;\n  padding: 16px;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n}\n\ntd {\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #334155;\n}\n\ntr:hover td {\n  background: #f1f5f9;\n}\n\n/* Enhanced Buttons */\n.edit-btn, .delete-btn, .add-credits-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: var(--transition);\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edit-btn {\n  background: var(--secondary-gradient);\n  color: white;\n}\n\n.delete-btn {\n  background: var(--danger-gradient);\n  color: white;\n}\n\n.add-credits-btn {\n  background: var(--success-gradient);\n  color: white;\n}\n\n/* Credits Management Enhancement */\n.credits-management {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.credits-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.credits-stat {\n  padding: 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.credits-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.credits-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* Environment Badge Enhancement */\n.environment-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.environment-badge.test {\n  background: rgba(33, 150, 243, 0.1);\n  color: #2196f3;\n}\n\n.environment-badge.live {\n  background: rgba(239, 83, 80, 0.1);\n  color: #ef5350;\n}\n\n/* Add some spacing for the environment select */\nselect[name=\"environment\"] {\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.notifications-section {\n  padding: 20px;\n}\n\n.section-description {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.notification-test-form {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notification-test-form .form-group {\n  margin-bottom: 15px;\n}\n\n.notification-test-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.notification-test-form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.create-notification-btn {\n  width: 100%;\n  padding: 12px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.create-notification-btn:hover {\n  background-color: #388E3C;\n}\n\n.create-notification-btn:disabled {\n  background-color: #9E9E9E;\n  cursor: not-allowed;\n}\n\n.notification-result {\n  margin-top: 15px;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.notification-result.success {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #388E3C;\n  border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.notification-result.error {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #D32F2F;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.notification-info {\n  margin-top: 30px;\n}\n\n.notification-types-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.notification-types-list li {\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-types-list li:last-child {\n  border-bottom: none;\n}\n\n.credits-management {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-top: 5px;\n}\n\n.credits-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.credits-field input {\n  width: 120px;\n}\n\n.credits-info {\n  display: flex;\n  gap: 20px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.add-credits-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  align-self: flex-start;\n  margin-top: 5px;\n}\n\n.add-credits-btn:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 768px) {\n  .admin-header {\n    padding: 20px;\n  }\n\n  .admin-nav {\n    padding: 0 16px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .admin-content {\n    padding: 16px;\n  }\n\n  .credits-info {\n    grid-template-columns: 1fr;\n  }\n\n  .table-container {\n    margin: 0 -16px;\n    border-radius: 0;\n  }\n\n  .add-form {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .add-form input,\n  .add-form select,\n  .add-form textarea {\n    margin-bottom: 8px;\n  }\n\n  table, thead, tbody, th, td, tr {\n    display: block;\n  }\n\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  tr {\n    margin-bottom: 16px;\n    border: 1px solid var(--border-color);\n    border-radius: var(--radius-sm);\n  }\n\n  td {\n    display: flex;\n    flex-direction: column;\n    border: none;\n    padding: 8px 12px;\n    text-align: left;\n    min-height: 60px;\n    position: relative;\n  }\n\n  td:before {\n    content: attr(data-label);\n    font-weight: bold;\n    margin-bottom: 4px;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    position: static;\n  }\n\n  td:last-child {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  td:last-child:before {\n    margin-bottom: 8px;\n  }\n\n  td:last-child > div {\n    display: flex;\n    gap: 8px;\n  }\n\n  .edit-form {\n    padding: 16px;\n  }\n\n  .edit-form form > div {\n    margin-bottom: 12px;\n  }\n\n  .form-buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .form-buttons button {\n    width: 100%;\n  }\n\n  .edit-btn,\n  .delete-btn {\n    flex: 1;\n    text-align: center;\n  }\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  font-size: 1.2rem;\n  color: var(--text-secondary);\n}\n\n.edit-form {\n  background: #f5f5f5;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.edit-form h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.edit-form form > div {\n  margin-bottom: 15px;\n}\n\n.edit-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.edit-form input,\n.edit-form select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.form-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.form-buttons button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.form-buttons button[type=\"submit\"] {\n  background: #4CAF50;\n  color: white;\n}\n\n.form-buttons button[type=\"button\"] {\n  background: #f44336;\n  color: white;\n}\n\n.reports-section {\n  padding: 20px;\n}\n\n.business-checks {\n  margin-bottom: 30px;\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.business-checks h3 {\n  margin-bottom: 15px;\n  color: #333;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 10px;\n}\n\n.business-summary {\n  margin: 10px 0;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.business-summary p {\n  margin: 5px 0;\n  font-weight: bold;\n}\n\n/* Add some spacing for the environment select */\nselect[name=\"environment\"] {\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.notifications-section {\n  padding: 20px;\n}\n\n.section-description {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.notification-test-form {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notification-test-form .form-group {\n  margin-bottom: 15px;\n}\n\n.notification-test-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.notification-test-form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.create-notification-btn {\n  width: 100%;\n  padding: 12px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.create-notification-btn:hover {\n  background-color: #388E3C;\n}\n\n.create-notification-btn:disabled {\n  background-color: #9E9E9E;\n  cursor: not-allowed;\n}\n\n.notification-result {\n  margin-top: 15px;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.notification-result.success {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #388E3C;\n  border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.notification-result.error {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #D32F2F;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.notification-info {\n  margin-top: 30px;\n}\n\n.notification-types-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.notification-types-list li {\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-types-list li:last-child {\n  border-bottom: none;\n}\n\n.credits-management {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-top: 5px;\n}\n\n.credits-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.credits-field input {\n  width: 120px;\n}\n\n.credits-info {\n  display: flex;\n  gap: 20px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.add-credits-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  align-self: flex-start;\n  margin-top: 5px;\n}\n\n.add-credits-btn:hover {\n  background-color: #218838;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.credits-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.credits-input-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.credits-input-group input:focus {\n  border-color: #2196f3;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.quick-credit-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.quick-credit-buttons button {\n  flex: 1;\n  padding: 8px 16px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  color: #475569;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.quick-credit-buttons button:hover {\n  background: #e2e8f0;\n  transform: translateY(-1px);\n}\n\n.quick-credit-buttons button:active {\n  transform: translateY(0);\n}\n\n.credits-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.credits-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.credits-input:focus {\n  outline: none;\n  border-color: #2196f3;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.credits-input::-webkit-inner-spin-button,\n.credits-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.credits-input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.credits-actions {\n  margin-top: 16px;\n}\n\n.credits-stat {\n  background: #f8fafc;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.credits-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.credits-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.manual-checks-group {\n  background: #f8fafc;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.manual-checks-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.manual-checks-info {\n  flex: 1;\n}\n\n.manual-checks-info label {\n  display: block;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 4px;\n}\n\n.manual-checks-info small {\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n/* Toggle Switch Styles */\n.toggle-container {\n  position: relative;\n  min-width: 60px;\n}\n\n.toggle-checkbox {\n  display: none;\n}\n\n.toggle-label {\n  display: block;\n  width: 60px;\n  height: 34px;\n  border-radius: 17px;\n  background: #cbd5e1;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.3s ease;\n}\n\n.toggle-label:before {\n  content: '';\n  display: block;\n  width: 26px;\n  height: 26px;\n  border-radius: 13px;\n  background: white;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  transition: transform 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-checkbox:checked + .toggle-label {\n  background: #2196f3;\n}\n\n.toggle-checkbox:checked + .toggle-label:before {\n  transform: translateX(26px);\n}\n\n.toggle-checkbox:focus + .toggle-label {\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
